// Libraries
import { PayloadAction, createSlice } from "@reduxjs/toolkit";

// Types
import { DefaultCoverageState, FeaturesState } from "store/types/features.types";

const initialFeaturesState: FeaturesState = {
  coverage: DefaultCoverageState,
};

const featuresSlice = createSlice({
  name: "features",
  initialState: initialFeaturesState,
  reducers: {
    setCoverage: (state, action: PayloadAction<FeaturesState["coverage"]>) => {
      state.coverage = action.payload;
    },
  },
});

export const { setCoverage } = featuresSlice.actions;
export default featuresSlice.reducer;
